import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselTextFn = /* @__PURE__ */ createRecipe('carousel-text', {}, [])

const carouselTextVariantMap = {}

const carouselTextVariantKeys = Object.keys(carouselTextVariantMap)

export const carouselText = /* @__PURE__ */ Object.assign(memo(carouselTextFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselText',
  __getCompoundVariantCss__: carouselTextFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselTextVariantKeys,
  variantMap: carouselTextVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselTextVariantKeys)
  },
  getVariantProps: carouselTextFn.getVariantProps,
})